/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { BroadcastMsg } from '../../models/broadcast-msg';

export interface GetBroadcastMessageById$Params {
  messageId: number;
}

export function getBroadcastMessageById(
  http: HttpClient,
  rootUrl: string,
  params: GetBroadcastMessageById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<BroadcastMsg>> {
  const rb = new RequestBuilder(rootUrl, getBroadcastMessageById.PATH, 'get');
  if (params) {
    rb.path('messageId', params.messageId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BroadcastMsg>;
      }),
    );
}

getBroadcastMessageById.PATH = '/message/{messageId}';
